import React from "react";
import MuiListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";

/**
 * ListItemText component wrapper for list item text content.
 * Wraps Material-UI ListItemText with theme integration.
 * 
 * @component
 * @example
 * <ListItemText primary="Primary text" secondary="Secondary text" />
 */
const ListItemText = (props) => {
  return <MuiListItemText {...props} />;
};

ListItemText.propTypes = {
  /**
   * If true, the children won't be wrapped by a Typography component
   */
  disableTypography: PropTypes.bool,
  /**
   * If true, the children are indented
   */
  inset: PropTypes.bool,
  /**
   * The main content element
   */
  primary: PropTypes.node,
  /**
   * These props will be forwarded to the primary typography component
   */
  primaryTypographyProps: PropTypes.object,
  /**
   * The secondary content element
   */
  secondary: PropTypes.node,
  /**
   * These props will be forwarded to the secondary typography component
   */
  secondaryTypographyProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI ListItemText behavior

export default ListItemText;

